import React from "react";
import Layout from "@components/layout";
import Header from "@components/header";
import SignupModal from "@components/terms_of_service/signup_modal";
import Dashboard from "@/pages/dashboard";
import { Option } from "@sprout/select";

type Props = {
  email: string;
  createPath: string;
  employmentTypes: Option[];
  worksites: Option[];
};

const NewUser = ({ email, createPath, employmentTypes, worksites }: Props) => {
  const paths = {
    notificationSchedulePath: "#",
    recentlyViewedJobsPath: "#",
    quickApplyPath: "#",
    workPreferencesPath: "#",
  };
  return (
    <>
      <div aria-hidden className="blur-xs pointer-events-none select-none">
        <Header />
        <Dashboard
          preview
          email={email}
          paths={paths}
          recentlyViewedJobsPerPageDashboard={5}
          newUser={true}
          employmentTypes={employmentTypes}
          worksites={worksites}
        />
      </div>
      <SignupModal email={email} createPath={createPath} />
    </>
  );
};

NewUser.layout = (page: React.ReactNode) => <Layout publicFacing>{page}</Layout>;

export default NewUser;
